function Slider(containerSelector) {
    this.containerSelector = containerSelector;
    this.container = JS.selectFirst(this.containerSelector);

    if (this.container != null) {
        this.isSingle = (this.container.getAttribute('data-single') == 'true') ? true : false;
        this.instance = this.init();
    }
}
Slider.prototype.isSingle = null;
Slider.prototype.containerSelector = null;
Slider.prototype.instance = null;
Slider.prototype.init = function() {
    var self = this;
    return new Swiper (this.containerSelector, {
        // Optional parameters
        loop: !self.isSingle,
        autoplay: self.isSingle ? 0 : 5000,
        simulateTouch: !self.isSingle,
        pagination: this.containerSelector +' .swiper-pagination',
        paginationClickable: true,
    })
}

function CMap(container, opt) {

    var self = this;
    document.addEventListener('DOMContentLoaded', function(){
        if (container != null) {
            self.container = container;

            // Set custom options passed to plugin
            self.setOptions(opt);

            // Check if google maps is loaded, if not load it
            self.initLoading(self);

            // Initializing map when google maps is available
            self.initMap(self);
        }
    });
}
CMap.prototype.container = null;
CMap.prototype.mapInstance = null;
CMap.prototype.repeatChecking = null;

CMap.prototype.location = null;
CMap.prototype.markerUrl = null;
CMap.prototype.googleAPI = null;
CMap.prototype.disableUI = false;
CMap.prototype.zoom = 7;
CMap.prototype.mapCenter = null;
CMap.prototype.mapCenterOffsetX = 0;
CMap.prototype.mapCenterOffsetY = 0;
CMap.prototype.scrollWheel = false;

CMap.prototype.initMap = function(self) {
    if (!JS.isSet(window.googleMapsLoaded) && !window.googleMapsLoaded) {
        self.repeatChecking = setInterval(function(){
            if (window.googleMapsLoaded) {
                self.expandGooglePrototype();
                self.init();
                clearInterval(self.repeatChecking);
            }
        }, 100);
    } else {
        self.expandGooglePrototype();
        self.init();
    }

};

CMap.prototype.initLoading = function(self) {
    if (!JS.isSet(window.googleMapsLoading)) {
        window.googleMapsLoading = true;
        JS.loadScript("https://maps.googleapis.com/maps/api/js?key=" + self.googleAPI, function () {
            window.googleMapsLoaded = true;
        });
    }
};

CMap.prototype.onResize = function() {
    if (window.innerWidth < 768) {
        // this.mapInstance.setCenterWithOffset(this.mapCenter, 0, 0);
        this.mapInstance.setOptions({
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: false
        });
    } else {
        // this.mapInstance.setCenterWithOffset(this.mapCenter, this.mapCenterOffsetX, this.mapCenterOffsetY);
        this.mapInstance.setOptions({
            streetViewControl: true,
            mapTypeControl: true,
            zoomControl: true
        });
    }
};

CMap.prototype.setOptions = function(opt) {
    this.location           = (JS.isSet(opt) && JS.isSet(opt.location)) ? opt.location : this.location;
    this.markerUrl          = (JS.isSet(opt) && JS.isSet(opt.markerUrl)) ? opt.markerUrl : this.markerUrl;
    this.googleAPI          = (JS.isSet(opt) && JS.isSet(opt.googleAPI)) ? opt.googleAPI : this.googleAPI;
    this.disableUI          = (JS.isSet(opt) && JS.isSet(opt.disableUI)) ? opt.disableUI : this.disableUI;
    this.zoom               = (JS.isSet(opt) && JS.isSet(opt.zoom)) ? opt.zoom : this.zoom;
    this.mapCenterOffsetX   = (JS.isSet(opt) && JS.isSet(opt.mapCenterOffsetX)) ? opt.mapCenterOffsetX : this.mapCenterOffsetX;
    this.mapCenterOffsetY   = (JS.isSet(opt) && JS.isSet(opt.mapCenterOffsetY)) ? opt.mapCenterOffsetY : this.mapCenterOffsetY;
    this.scrollWheel        = (JS.isSet(opt) && JS.isSet(opt.scrollWheel)) ? opt.scrollWheel : this.scrollWheel;
};

CMap.prototype.setMapInstance = function () {
    this.mapInstance = new google.maps.Map(this.container, {
        zoom: this.zoom,
        center: this.mapCenter,
        disableDefaultUI: this.disableUI,
        scrollwheel: this.scrollWheel
    });
};

CMap.prototype.addMarker = function(location) {
    var markerOptions = {
        position: new google.maps.LatLng(location.lat, location.lng),
        map: this.mapInstance,
        animation: google.maps.Animation.DROP,
        icon: this.markerUrl
    };
    var marker = new google.maps.Marker(markerOptions);
    marker.setMap(this.mapInstance);
};

CMap.prototype.init = function() {
    // setting default map center
    // if locations not empty, setting center on first location in the array
    // if not, centering label of Lithuania
    this.mapCenter  = {
        lat: (this.location) ? parseFloat(this.location.lat) : 55.409316,
        lng: (this.location) ? parseFloat(this.location.lng) : 24.064840,
    };

    this.setMapInstance();
    this.onResize();
    var self = this;

    JS.addEvent(window, 'resize', function () {
        self.onResize();
    });

    if (this.location) this.addMarker(this.location);
};

CMap.prototype.expandGooglePrototype = function() {
    /*
    google.maps.CMap.prototype.setCenterWithOffset= function(latlng, offsetX, offsetY) {
        var map = this;
        var ov = new google.maps.OverlayView();
        latlng = new google.maps.LatLng(latlng.lat, latlng.lng);

        ov.onAdd = function() {
            var proj = this.getProjection();
            var aPoint = proj.fromLatLngToContainerPixel(latlng);
            aPoint.x = aPoint.x+offsetX;
            aPoint.y = aPoint.y+offsetY;
            map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
        };
        ov.draw = function() {};
        ov.setMap(this);
    };
    */
}
function ImageZoom(container, opt) {
    var self = this;
    document.addEventListener('DOMContentLoaded', function(){
        if (container != null) {
            self.container = container;

            var waitForSvgAbort = 0;
            var waitForSvg = setInterval(function(){
                if (JS.selectFirst('svg', this.container)) {
                    self.imageCenters.push({
                        el: JS.selectFirst('.center-1', this.container),
                        scale: {
                            mobile: 5,
                            tablet: 3,
                            desktop: 0.3
                        }
                    });
                    self.imageCenters.push({
                        el: JS.selectFirst('.center-2', this.container),
                        scale: {
                            mobile: 5,
                            tablet: 3,
                            desktop: 3
                        }
                    });
                    self.imageCenters.push({
                        el: JS.selectFirst('.center-3', this.container),
                        scale: {
                            mobile: 2.5,
                            tablet: 2.5,
                            desktop: 2.6
                        }
                    });
                    // Set custom options passed to plugin
                    self.setOptions(opt);
                    self.init();
                    clearInterval(waitForSvg);
                }
                waitForSvgAbort++;

                if (waitForSvgAbort > 1000) clearInterval(waitForSvg);
            }, 10);
        }
    });
}

ImageZoom.prototype.container       = null;
ImageZoom.prototype.aspectRatio     = 1;
ImageZoom.prototype.image           = null;
ImageZoom.prototype.imageContainer  = null;
ImageZoom.prototype.imageCenters    = [];
ImageZoom.prototype.currentCenter   = null;
ImageZoom.prototype.lastScale       = 1;
ImageZoom.prototype.currentScale    = 1;
ImageZoom.prototype.translateX      = 0;
ImageZoom.prototype.translateY      = 0;
ImageZoom.prototype.isZooming       = false;
ImageZoom.prototype.navigationItems = [];
ImageZoom.prototype.isResizing      = null;

ImageZoom.prototype.setOptions = function(opt) {
    this.imageContainer  = JS.selectFirst('.inner-holder', this.container);
    this.image           = JS.selectFirst('.map-image', this.imageContainer);
    this.aspectRatio     = parseInt(this.image.getAttribute('height')) / parseInt(this.image.getAttribute('width'));
    this.navigationItems = JS.selectAll('.menu-item', (JS.isSet(opt) && JS.isSet(opt.nav)) ? opt.nav : this.container.parentNode);
};

ImageZoom.prototype.init = function() {
    var self = this;

    this.draw();
    if (this.navigationItems.length > 0)
        this.initNavigation();

    JS.addEvent(window, 'resize', function () {
        clearTimeout(self.isResizing);
        self.isResizing = setTimeout(function() {
            if (!self.isZooming)
                self.draw();
        }, 2000);
    })
};

ImageZoom.prototype.initNavigation = function() {
    var self = this;
    for (var i=0;i<this.navigationItems.length;i++)
        JS.addEvent(this.navigationItems[i], 'click', function(){
            self.navigateCenter(parseInt(this.getAttribute('data-index')));
        });
    this.navigateCenter(1);
};

ImageZoom.prototype.navigateCenter = function(index) {
    if (!this.isZooming) {
        for (var i=0;i<this.navigationItems.length;i++) {
            JS.removeClass(this.navigationItems[i], 'active');
        }
        JS.addClass(this.navigationItems[index], 'active');

        this.setCenter(index);
        this.isZooming = true;
    }
}

ImageZoom.prototype.draw = function() {
    var self = this;
    // this.container.style.width = window.innerWidth + "px";
    // this.container.style.height = (window.innerWidth * this.aspectRatio) + "px";
    if (this.currentCenter != null) {
        this.calculateCenterOffsets();
        setTimeout(function(){
            self.isZooming = false;
        }, 1500);
    }
};

// Sets horizontal and vertical translation to center point on image on the screen
ImageZoom.prototype.calculateCenterOffsets = function() {
    if (this.imageCenters[this.currentCenter].el == null) {
        console.warn('No image center detected');
        return;
    }
    var imageCenterOffset       = this.imageCenters[this.currentCenter].el.getBoundingClientRect();
    var imageContainerOffset    = this.imageContainer.getBoundingClientRect();
    var imageContainerHeight    = imageContainerOffset.bottom - imageContainerOffset.top;

    this.translateX = (window.innerWidth/2) - imageCenterOffset.left + this.translateX;
    this.translateY = (imageContainerHeight/2) + imageContainerOffset.top - imageCenterOffset.top + this.translateY;

    this.image.style.transform = "translateX("+this.translateX+"px) translateY("+this.translateY+"px)";
};

ImageZoom.prototype.setCenter = function(index) {
    if ((typeof this.imageCenters[index] != "undefined") && (this.currentCenter != index)) {
        this.currentCenter = index;
        this.draw();
    }
};

ImageZoom.prototype.setScale = function(value) {
    this.lastScale      = this.currentScale;
    this.currentScale   = value;
    return this;
};

ImageZoom.prototype.scaleRect = function(original, scale) {
    return {
        top: original.top * scale,
        left: original.left * scale
    }
};

ImageZoom.prototype.getRelativeOffset = function(obj) {
    var childPos    = obj.getBoundingClientRect();
    var parentPos   = obj.parentNode.getBoundingClientRect();

    var childOffset = {
        top: (childPos.top - parentPos.top),
        left: (childPos.left - parentPos.left)
    }

    return childOffset;
};
